import {doc} from './docs.js';
import {isInputEvent} from "utils/isInputEvent.js";

doc(

    "key.shortcut",
    {
        "bang": "",
        "key": "",
    },
    "Listens for key press events and triggers a bang when they occur",
    undefined,
    {
        tags: "Keyboard",
        isHot: true,
        inlets: 2
    }
);
export const keyshortcut = (object, key) => {
    let lastKey = undefined;
    object.needsLoad = true;

    const onKey = (e) => {
        if (isInputEvent(e)) {
            return;
        }
        if (e.key === lastKey) {
            if (object.sequencerEngine.isAnyTrackEnabled()) {
                return;
            }
            object.sendMessage(
                object.outputByNumber(0),
                "bang");
        }
    };

    window.addEventListener('keydown', onKey);

    return (msg) => {
        let _key = key();

        if (msg[0] === "dispose") {
            if (lastKey) {
                if (object.sequencerEngine.keyListener) {
                    object.sequencerEngine.keyListener.removeBinding(lastKey);
                }
            }
            window.removeEventListener('keydown', onKey);
            return;
        }

        if (lastKey && _key !== lastKey) {
            if (object.sequencerEngine.keyListener) {
                object.sequencerEngine.keyListener.removeBinding(lastKey);
            }
        } 

        if (_key && _key !== lastKey) {
            if (object.sequencerEngine.keyListener) {
                object.sequencerEngine.keyListener.addBinding(_key);
            }
        }

        lastKey = _key;
    };
};

doc(
    "key.down",
    {
        "bang": "",
        "key": "",
    },
    "Listens for key press events and triggers a bang when they occur",
    undefined,
    {
        tags: "Keyboard",
        isHot: true,
        inlets: 2
    }
);
export const keydown = (object, key) => {
    let lastKey = undefined;
    object.needsLoad = true;

    const onKey = (e) => {
        if (isInputEvent(e)) {
            return;
        }
        if (e.key === lastKey) {
            if (object.sequencerEngine.isAnyTrackEnabled()) {
                return;
            }
            object.sendMessage(
                object.outputByNumber(0),
                "bang");
        }
    };

    window.addEventListener('keydown', onKey);

    return (msg) => {
        let _key = key();

        if (msg[0] === "dispose") {
            if (lastKey) {
                if (object.sequencerEngine.keyListener &&
                    object.sequencerEngine.keyListener.removeBinding) {
                    object.sequencerEngine.keyListener.removeBinding(lastKey);
                }
            }
            window.removeEventListener('keydown', onKey);
            return;
        }

        if (lastKey && _key !== lastKey) {
            if (object.sequencerEngine.keyListener) {
                object.sequencerEngine.keyListener.removeBinding(lastKey);
            }
        } 

        if (_key && _key !== lastKey) {
            if (object.sequencerEngine.keyListener) {
                
                object.sequencerEngine.keyListener.addBinding(_key);
            }
        }

        lastKey = _key;
    };
};

doc(
    "key.up",
    {
        "bang": "",
        "key": "",
    },
    "Listens for key up events and triggers a bang when they occur",
    undefined,
    {
        tags: "Keyboard",
        isHot: true,
        inlets: 2
    }
);
export const keyup = (object, key) => {
    let lastKey = undefined;
    object.needsLoad = true;

    const onKey = (e) => {
        if (isInputEvent(e)) {
            return;
        }
        if (e.key === lastKey) {
            if (object.sequencerEngine.isAnyTrackEnabled()) {
                return;
            }
            object.sendMessage(
                object.outputByNumber(0),
                "bang");
        }
    };

    window.addEventListener('keyup', onKey);

    return (msg) => {
        let _key = key();

        if (msg[0] === "dispose") {
            if (lastKey) {
                if (object.sequencerEngine.keyListener) {
                    object.sequencerEngine.keyListener.removeBinding(lastKey);
                }
            }
            window.removeEventListener('keyup', onKey);
            return;
        }

        if (lastKey && _key !== lastKey) {
            if (object.sequencerEngine.keyListener) {
                object.sequencerEngine.keyListener.removeBinding(lastKey);
            }
        } 

        if (_key && _key !== lastKey) {
            if (object.sequencerEngine.keyListener) {
                object.sequencerEngine.keyListener.addBinding(_key);
            }
        }

        lastKey = _key;
    };
};



export const keyboard = {
    "key.shortcut": keyshortcut,
    "key.up": keyup,
    "key.down": keydown,
};
